import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=0f2f3c45&lang=pug"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=0f2f3c45&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports